<ng-container *ngFor="let key of phoneKeys">
  <div
    *ngIf="!!log && hasLog(key, log)"
    [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML : phoneNumberLookup : phoneKeyWithLookup[key] ?? null"
  ></div>
</ng-container>
